import * as React from 'react';
import { snap, visualize } from 'storybook-snapper';
import { HeroImage } from '..';

const sampleSource = 'f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg';
const sampleDimensions = { width: 800, height: 300 };

visualize('HeroImage', () => {
  snap('default', (done) => (
    <HeroImage src={sampleSource} {...sampleDimensions} onLoad={done} />
  ));
});
